/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import { handleApiError } from "@utils/errorHandler";
import {
  BoxInfo,
  GridRow,
  NoDocument,
  ButtonWrapper,
  ButtonData,
  ErrorMessage,
} from "./BoxList.styled";

const BoxList = (props) => {
  const { t, boxId, setsBoxId, entityId, type, updateRefeshStatus } = props;

  const [createBoxPIError, setCreateBoxPIError] = useState("");
  const [isBoxCreating, setIsBoxCreating] = useState(false);

  const createBox = () => {
    setIsBoxCreating(true);
    const formData = { entityId, entityType: type };
    axios
      .post(`/documents/box/createFolder`, formData)
      .then((response) => {
        setIsBoxCreating(false);
        if (response.data.status) {
          setsBoxId(response.data.folderId);
          updateRefeshStatus();
        } else {
          setCreateBoxPIError(response.data?.message ?? "");
        }
      })
      .catch((error) => handleApiError(error));
  };

  return (
    <BoxInfo>
      {!boxId && (
        <GridRow column="1fr 1fr">
          <>
            <NoDocument>{t("NO_BOX_FOLDER")}</NoDocument>
            {createBoxPIError && (
              <ErrorMessage>{createBoxPIError}</ErrorMessage>
            )}
          </>

          <ButtonWrapper>
            <ButtonData onClick={createBox}>
              <>
                {isBoxCreating && <ClipLoader size={15} color="#fff" />}
                {!isBoxCreating && t("CREATE_BOX_FOLDER")}
              </>
            </ButtonData>
          </ButtonWrapper>
        </GridRow>
      )}
      {!!boxId && (
        <iframe
          title="boxtitle98490593744"
          src={`https://hesus.app.box.com/embed/folder/${boxId}?view=list&sortColumn=date`}
          width="100%"
          height="600"
          frameBorder="0"
          allowfullscreen="allowfullscreen"
        />
      )}
    </BoxInfo>
  );
};

BoxList.propTypes = {
  t: PropTypes.func.isRequired,
  entityId: PropTypes.number.isRequired,
  boxId: PropTypes.number,
  type: PropTypes.number.isRequired,
  setsBoxId: PropTypes.func.isRequired,
  updateRefeshStatus: PropTypes.func,
};

BoxList.defaultProps = {
  boxId: null,
  updateRefeshStatus: () => {},
};

export default withTranslation()(BoxList);
